import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { FaCogs, FaChartLine, FaBoxes, FaMicrochip, FaCheckCircle } from "react-icons/fa";
import pcbHero from "../../assets/PCB.png"; // replace with your hero image
import "./PCBManucfucture.css";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";

function PCBManufacture() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pcb-page">
      <Header />

      {/* All page-specific content wrapped here */}
      <div className="pcb-page-content">
        {/* Hero Section */}
        <section
          className="pcb-hero"
          style={{ backgroundImage: `url(${pcbHero})` }}
        >
          <div className="pcb-hero-overlay"></div>
          <h1 className="pcb-hero-title">MES for PCB Plate Process</h1>
        </section>

        {/* Hero Content */}
        <section className="pcb-hero-content">
          <h2>Optimize Your PCB Production</h2>
          <p>
            Our Manufacturing Execution System (MES) for PCB plate process
            streamlines production, ensures quality, and provides real-time insights.
          </p>
        </section>

        {/* Feature Flow Section */}
        <section className="pcb-process-flow">
          <h2>Key Features</h2>
          <div className="pcb-process-steps">
            <div className="pcb-step">
              <FaCogs className="pcb-step-icon" />
              <h3>Real-Time Tracking</h3>
              <p>Monitor thawing, viscosity, soldering, and mounter machine processes in real-time.</p>
            </div>
            <div className="pcb-step">
              <FaMicrochip className="pcb-step-icon" />
              <h3>Automated Data Collection</h3>
              <p>Collect machine data, process parameters, and product quality automatically.</p>
            </div>
            <div className="pcb-step">
              <FaChartLine className="pcb-step-icon" />
              <h3>Process Control</h3>
              <p>Ensure adherence to process standards and detect deviations immediately.</p>
            </div>
            <div className="pcb-step">
              <FaCheckCircle className="pcb-step-icon" />
              <h3>Quality Management</h3>
              <p>Track and analyze defects, yields, and process variations effectively.</p>
            </div>
          </div>
        </section>

       {/* Benefits Section */}
<section className="pcb-benefits">
  <h2>Benefits of MES for PCB Production</h2>
  <div className="pcb-benefit-item">
    <FaCogs className="pcb-benefit-icon" />
    <div>
      <h3>Improved Efficiency</h3>
      <p>Optimize workflows, reduce downtime, and enhance overall productivity.</p>
    </div>
  </div>
  <div className="pcb-benefit-item">
    <FaCheckCircle className="pcb-benefit-icon" />
    <div>
      <h3>Enhanced Quality</h3>
      <p>Ensure consistent product quality and minimize defects throughout production.</p>
    </div>
  </div>
  <div className="pcb-benefit-item">
    <FaChartLine className="pcb-benefit-icon" />
    <div>
      <h3>Data-Driven Decisions</h3>
      <p>Leverage real-time data and analytics to make smarter, faster decisions.</p>
    </div>
  </div>
</section>

{/* Modules Section */}
<section className="pcb-modules">
  <h2>MES Modules</h2>
  <div className="pcb-modules-timeline">
    <div className="pcb-module">
      <div className="pcb-module-dot"></div>
      <div className="pcb-module-content">
        <h3>Production Tracking</h3>
        <p>Track production progress and machine utilization.</p>
      </div>
    </div>
    <div className="pcb-module">
      <div className="pcb-module-dot"></div>
      <div className="pcb-module-content">
        <h3>Quality Control</h3>
        <p>Monitor and control product quality at each stage.</p>
      </div>
    </div>
    <div className="pcb-module">
      <div className="pcb-module-dot"></div>
      <div className="pcb-module-content">
        <h3>Inventory Management</h3>
        <p>Manage raw materials and finished goods efficiently.</p>
      </div>
    </div>
  </div>
</section>


        {/* Impact Section */}
        <section className="pcb-impact">
          <h2>Streamline Your PCB Production</h2>
          <p>
            Implementing our MES system helps you improve efficiency, ensure high-quality
            products, and make informed decisions for optimized PCB plate production.
          </p>
        </section>
      </div>

      <Footer />
      <ERPChatbot />
    </div>
  );
}

export default PCBManufacture;
